// TODO: Dark mode
export const HistoryPointIcon = () => {
  return (
    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 24.2188C0 10.9639 10.7452 0.21875 24 0.21875C37.2548 0.21875 48 10.9639 48 24.2188C48 37.4736 37.2548 48.2188 24 48.2188C10.7452 48.2188 0 37.4736 0 24.2188Z"
        fill="#1A1A29"
        fillOpacity="0.07"
      />
      <path
        d="M27 24.2188C27 25.8757 25.6569 27.2188 24 27.2188C22.3431 27.2188 21 25.8757 21 24.2188C21 22.5618 22.3431 21.2188 24 21.2188C25.6569 21.2188 27 22.5618 27 24.2188Z"
        fill="#B2B2BA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 13.2188C24.5523 13.2188 25 13.6665 25 14.2188V15.2737C29.1716 15.7348 32.4839 19.0471 32.9451 23.2188H34C34.5523 23.2188 35 23.6665 35 24.2188C35 24.771 34.5523 25.2188 34 25.2188H32.9451C32.4839 29.3904 29.1716 32.7027 25 33.1639V34.2188C25 34.771 24.5523 35.2188 24 35.2188C23.4477 35.2188 23 34.771 23 34.2188V33.1639C18.8284 32.7027 15.5161 29.3904 15.0549 25.2188H14C13.4477 25.2188 13 24.771 13 24.2188C13 23.6665 13.4477 23.2188 14 23.2188H15.0549C15.5161 19.0471 18.8284 15.7348 23 15.2737V14.2188C23 13.6665 23.4477 13.2188 24 13.2188ZM25 31.1479V30.2188C25 29.6665 24.5523 29.2188 24 29.2188C23.4477 29.2188 23 29.6665 23 30.2188V31.1479C19.9343 30.7094 17.5094 28.2845 17.0709 25.2188H18C18.5523 25.2188 19 24.771 19 24.2188C19 23.6665 18.5523 23.2188 18 23.2188H17.0709C17.5094 20.1531 19.9343 17.7281 23 17.2896V18.2188C23 18.771 23.4477 19.2188 24 19.2188C24.5523 19.2188 25 18.771 25 18.2188V17.2896C28.0657 17.7281 30.4906 20.1531 30.9291 23.2188H30C29.4477 23.2188 29 23.6665 29 24.2188C29 24.771 29.4477 25.2188 30 25.2188H30.9291C30.4906 28.2845 28.0657 30.7094 25 31.1479Z"
        fill="#B2B2BA"
      />
    </svg>
  )
}
